export const jobTypes = [
  { value: 'all', label: 'All Types' },
  { value: 'full-time', label: 'Full Time' },
  { value: 'part-time', label: 'Part Time' },
  { value: 'internship', label: 'Internship' }
];

// Tags are now dynamically loaded from scraped jobs
export const popularTags = [];

// Locations and tags are now dynamically loaded from scraped jobs
export const locations = ['All Locations'];
